import type { ReactNode } from 'react';

export interface IReadFormLabelProps {
    children: ReactNode;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function ReadFormLabel(props: IReadFormLabelProps) {
    return (
        <label
            className="col-form-label read-form-label"
            data-dd-privacy="allow"
        >
            {props.children}
        </label>
    );
}
